"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=TableInterface.js.map